import { ReactElement } from "react";
import classNames from "classnames";
import FrameButton from "../buttons/FrameButton";
import { FaGoogle, FaDiscord } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { SiSteam, SiTwitch } from "react-icons/si";
import { MdEmail } from "react-icons/md";

export enum SocialProvider {
    GOOGLE = "google",
    DISCORD = "discord",
    X = "x",
    TWITCH = "twitch",
    STEAM = "steam",
    EMAIL = "email",
}

interface SocialLoginButtonsProps {
    onProviderSelect: (provider: SocialProvider) => void;
    isLoading?: boolean;
    selectedProvider?: SocialProvider | null;
}

function SocialLoginButtons({
    onProviderSelect,
    isLoading = false,
    selectedProvider,
}: SocialLoginButtonsProps): ReactElement {

    const socialProviders = [
        {
            id: SocialProvider.DISCORD,
            name: "Discord",
            icon: <FaDiscord />,
        },
        /*
         * Temporarily disabled - these providers don't provide email
         * {
         *  id: SocialProvider.STEAM,
         *  name: "Steam",
         *  icon: <SiSteam />
         * },
         * {
         *  id: SocialProvider.TWITCH,
         *  name: "Twitch",
         *  icon: <SiTwitch />
         * },
         */
        {
            id: SocialProvider.GOOGLE,
            name: "Google",
            icon: <FaGoogle />,
        },
        /*
         * Temporarily disabled - doesn't provide email
         * {
         *  id: SocialProvider.X,
         *  name: "X",
         *  icon: <FaXTwitter />
         * }
         */
    ];

    return (
        <div className="social-login-buttons">
            <div className="social-login-buttons__icon-row">
                {socialProviders.map((provider) =>
                    <button
                        key={provider.id}
                        className={classNames("social-login-buttons__icon-button", {
                            "social-login-buttons__icon-button--loading": isLoading && selectedProvider === provider.id,
                            "social-login-buttons__icon-button--disabled": isLoading && selectedProvider !== provider.id,
                        })}
                        onClick={() => onProviderSelect(provider.id)}
                        disabled={isLoading}
                        aria-label={`Login with ${provider.name}`}
                    >
                        {provider.icon}
                    </button>)}
            </div>

        </div>
    );
}

export default SocialLoginButtons;